/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import { Grid, MenuItem } from '@material-ui/core';
import React from 'react';
import { Field, useFormikContext } from 'formik';
import { TextField as FormikTextField } from 'formik-material-ui';
import { useTranslation } from 'react-i18next';
import CustomInputField from './CustomInputField';

const countries = [
  { name: 'USA', number: '+1', code: 'US' },
  { name: 'Canada', number: '+1', code: 'CA' },
  { name: 'Argentina', number: '+54', code: 'AR' },
  { name: 'Australia', number: '+61', code: 'AU' },
  { name: 'Austria', number: '+43', code: 'AT' },
  { name: 'Brazil', number: '+55', code: 'BR' },
  { name: 'France', number: '+33', code: 'FR' },
  { name: 'Germany', number: '+49', code: 'DE' },
  { name: 'Ireland', number: '+353', code: 'IE' },
  { name: 'Japan', number: '+81', code: 'JP' },
  { name: 'Mexico', number: '+52', code: 'MX' },
  { name: 'Netherlands', number: '+31', code: 'NL' },
  { name: 'New Zealand', number: '+64', code: 'NZ' },
  { name: 'Spain', number: '+34', code: 'ES' },
  { name: 'United Kingdom', number: '+44', code: 'GB' },
];
const PhoneInput = ({ value, onChange, ...rest }) => {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext();
  const onChangeCountryCode = (event) => {
    const phoneNumber =
      countries.find((c) => c.code === event.target.value)?.number +
      values.localPhone;
    setFieldValue('countryCode', event.target.value);
    onChange(phoneNumber);
  };

  const onChangeLocalPhone = (event) => {
    const phoneNumber =
      countries.find((c) => c.code === values.countryCode)?.number +
      event.target.value;
    onChange(phoneNumber);
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={5}>
        <Field
          component={FormikTextField}
          fullWidth
          select
          {...rest}
          value={value}
          name="countryCode"
          variant="outlined"
          onChange={onChangeCountryCode}
        >
          <MenuItem value={undefined}>---</MenuItem>
          {countries.map(({ name, number, code }) => (
            <MenuItem key={code} value={code}>
              {number} {name}
            </MenuItem>
          ))}
        </Field>
      </Grid>
      <Grid item xs={7}>
        <CustomInputField
          customInput={Field}
          component={FormikTextField}
          trim
          fullWidth
          required
          label={t('yourPhoneNumber')}
          name="localPhone"
          variant="outlined"
          onChange={onChangeLocalPhone}
        />
      </Grid>
    </Grid>
  );
};

PhoneInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default PhoneInput;
